export default __webpack_public_path__ + "static/moca-bcde5d5eaa234293f9b6e2d215758b16.jpg";